import { createSlice } from "@reduxjs/toolkit";

const sessionSlice = createSlice({
  name: "session",
  initialState: {
    token: null,
    user: null,
    name: "",
    roleName: "",
    accessRights: [],
    isSessionChecked: false,
    isLoading: false,
    error: null,
  },
  reducers: {
    setSession(state, action) {
      state.token = action.payload.token;
      state.user = action.payload.user || null;
      state.isSessionChecked = true;
      state.isLoading = false;
      state.error = null;
    },
    setUserInfo(state, action) {
      state.name = action.payload.name || "";
      state.roleName = action.payload.roleName || "";
    },
    setAccessRights(state, action) {
      state.accessRights = action.payload || [];
    },
    clearSession(state) {
      state.token = null;
      state.user = null;
      state.name = "";
      state.roleName = "";
      state.accessRights = [];
      state.isSessionChecked = true;
      state.isLoading = false;
      state.error = null;
    },
    setSessionChecked(state) {
      state.isSessionChecked = true;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setSession, setUserInfo, setAccessRights, clearSession, setSessionChecked, setLoading, setError } = sessionSlice.actions;
export default sessionSlice.reducer;
